import React from "react";
import { Container, LinearLine } from "../styles/porfolio";
import Projects from "../components/projectTab";
import { WindowBlack } from "../styles/home";
import { BackgroundAnimation } from "components/backgroundAnimation";

const Portfolio = () => {
  return (
    <WindowBlack>
      <BackgroundAnimation />
      <p className="stack-title">Works & Projects</p>
      <Container style={{ marginBottom: "20px" }}>
        <p
          style={{
            fontSize: "clamp(1rem, 3.5vw, 40px)",
            fontWeight: "bold",
            color: "var(--color-main-text)",
          }}
        >
          Crafting interactive and creative solutions
        </p>
        <Projects />
      </Container>
    </WindowBlack>
  );
};

export default Portfolio;
